import { render, staticRenderFns } from "./OxyClassTokenNameInput.vue?vue&type=template&id=313355ce&"
import script from "./OxyClassTokenNameInput.vue?vue&type=script&lang=ts&"
export * from "./OxyClassTokenNameInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxyClassTokenNameInput.vue?vue&type=style&index=0&id=313355ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports